interface BodyProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

export default function CardBody({
  children,
  className = '',
  ...rest
}: BodyProps) {
  return (
    <div className={`card-body ${className}`} {...rest}>
      {children}
    </div>
  );
}
